import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import Slider from '@dtvgo/slider';

/* Styles */
import './VolumeBar.scss';

function VolumeBar({
  volume,
  setVolume,
  isMuted,
}) {
  const minValue = 0;
  const maxValue = 100;

  return (
    <Slider
      className="dtv-common-c-volume-bar-v2 volume-bar-v2"
      minValue={minValue}
      maxValue={maxValue}
      onSetValue={setVolume}
      dragFromOutside
      focused
      stopClickPropagation
      vertical
      value={isMuted ? 0 : volume}
    >
      <Slider.Fill />
      <Slider.Dot />
    </Slider>
  );
}

VolumeBar.propTypes = {
  volume: PropTypes.number,
  isMuted: PropTypes.bool,
  setVolume: PropTypes.func,
};

VolumeBar.defaultProps = {
  volume: 0,
  isMuted: false,
  setVolume() {},
};

export default VolumeBar;
